$((event) => {
    let buttons = Array.from(document.querySelectorAll('.js__listing--delete'));

    buttons.forEach((element) => {
        element.addEventListener("click", (event) => {
            if (!confirm("Are you sure you want to delete this listing?"))
                return;

            $.ajax({
                url: element.dataset['url'],
                method: "POST",
                data: {
                    id: element.dataset['id']
                },

                // TODO: Add headers to global setup
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                }
            }).done((response) => {
                window.location.reload();
            }).fail((response) => {
                alert(response.responseJSON.message);
            });
        });
    });
});
